const passwordReveal = {};

passwordReveal.init = () => {

    let $btns = document.querySelectorAll(".password-reveal");
    for (let i = 0; i < $btns.length; i++) {
        $btns[i].addEventListener("click", togglePassword, false);
    }

    function togglePassword(e) {
        e.preventDefault();
        let $btn = e.target;
        let $field = $btn.parentElement.previousElementSibling;
        if($field) {
            let currentType = $field.getAttribute('type');
            $field.setAttribute('type', currentType === 'text' ? 'password' : 'text');
        }

    }

}

export default passwordReveal;
